import store from './store.js'

const Actions = (update$) => {
    return {
        changeViewTo(pg) {
            const view = { ...store.states$().pages }
            Object.keys(view).forEach(key => {
                view[key].view = false
            })
            view[pg].view = true
            store.states$()['activated-route'] = view[pg].name
            update$({ view })
        }

    }
}

export default Actions

